const ID_TOKEN_KEY = 'user-token';

export const getToken = () => window.localStorage.getItem(ID_TOKEN_KEY);

export const saveToken = (token) => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const getJWTData = () => {
  // JWT's are two base64-encoded JSON objects and a trailing signature
  // joined by periods. The middle section is the data payload.
  if (getToken()) return JSON.parse(atob(getToken().split('.')[1]));
  return {};
};

export default { getToken, saveToken, destroyToken };
